/* Progressive enhancement: all About content is readable before JS runs. */
if (!customElements.get('zb-about-page')) {
  customElements.define('zb-about-page', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.animations = [];
      this.setup = () => {
        this.observer?.disconnect();
        this.animations.forEach(animation => animation.cancel());
        this.animations = [];
        this.style.removeProperty('--zb-about-drift');
        if (this.motion.matches) return;
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
              if (!entry.isIntersecting) return;
              this.animations.push(entry.target.animate([
                { opacity: .35, transform: 'translateY(24px)' },
                { opacity: 1, transform: 'translateY(0)' }
              ], { duration: 700, easing: 'cubic-bezier(.2,.65,.3,1)' }));
              this.observer.unobserve(entry.target);
            });
          }, { threshold: .08 });
          this.querySelectorAll('[data-about-reveal]').forEach(node => this.observer.observe(node));
        }
      };
      this.motion.addEventListener('change', this.setup, { signal: this.abort.signal });
      this.setup();
      const update = () => {
        if (this.frame || this.motion.matches || innerWidth < 990) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          const media = this.querySelector('.zb-about-hero__media');
          if (!media) return;
          const rect = media.getBoundingClientRect();
          if (rect.bottom < 0 || rect.top > innerHeight) return;
          this.style.setProperty('--zb-about-drift', `${Math.max(-12, Math.min(12, (innerHeight / 2 - rect.top) * .025))}px`);
        });
      };
      addEventListener('scroll', update, { passive: true, signal: this.abort.signal });
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      this.animations?.forEach(animation => animation.cancel());
      if (this.frame) cancelAnimationFrame(this.frame);
    }
  });
}
